export default "__VITE_ASSET__d46d2f8e__"